// Pure grouping: views refer to the same document IDs; multi-tag documents appear in each tag.
export const VIEWS = ['folders', 'tags', 'date'];
export const normalized = s => String(s).normalize('NFKC').replace(/ي/g, 'ی').replace(/ك/g, 'ک').trim().toLowerCase();

export function dateFormat(lang, calendar, options = {}) {
  return new Intl.DateTimeFormat(lang === 'en' ? 'en-US' : 'fa-IR', {
    calendar: calendar === 'gregorian' ? 'gregory' : 'persian', timeZone: 'Asia/Tehran', ...options,
  });
}

export function groupsOf(documents, folders, view, { lang = 'fa', calendar = 'shamsi', unfiled = 'Unfiled', untagged = 'Untagged' } = {}) {
  const ordered = [...documents].sort((a, b) => b.updated_at - a.updated_at || a.id.localeCompare(b.id));
  if (view === 'folders') {
    const groups = folders.map(f => ({ key: f.id, name: f.name, documents: ordered.filter(d => d.folder_id === f.id) }));
    groups.push({ key: '', name: unfiled, documents: ordered.filter(d => !d.folder_id) });
    return groups;
  }
  if (view === 'tags') {
    const tags = [...new Set(ordered.flatMap(d => d.tags))].sort((a, b) => a.localeCompare(b, lang));
    const groups = tags.map(tag => ({ key: tag, name: tag, documents: ordered.filter(d => d.tags.includes(tag)) }));
    groups.push({ key: '', name: untagged, documents: ordered.filter(d => !d.tags.length) });
    return groups;
  }
  const fmt = dateFormat(lang, calendar, { year: 'numeric', month: 'long' });
  const keys = dateFormat('en', calendar, { year: 'numeric', month: '2-digit' });
  const groups = new Map();
  for (const d of ordered) {
    const p = Object.fromEntries(keys.formatToParts(d.updated_at).map(x => [x.type, x.value]));
    const key = `${p.year}-${p.month}`;
    if (!groups.has(key)) groups.set(key, { key, name: fmt.format(d.updated_at), documents: [] });
    groups.get(key).documents.push(d);
  }
  return [...groups.values()];
}
